// src/components/usersession.tsx (CORRECTED)

// import { Dialog } from "@headlessui/react";
// import { XMarkIcon } from "@heroicons/react/24/outline";
// import { useState, useEffect, useCallback } from "react";
// import { useNavigate, useLocation } from "react-router-dom";

const UserSessionContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  // const [dialogOpen, setDialogOpen] = useState(true);
  // const [tokenInput, setTokenInput] = useState("");
  // const [error, setError] = useState<string | null>(null);
  // const navigate = useNavigate();
  // const location = useLocation();

  // const validateToken = useCallback(async (tokenToValidate: string) => {
  //   try {
  //     const response = await fetch("https://api.izzat.xyz/data", {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${tokenToValidate}`,
  //       },
  //     });

  //     if (!response.ok) {
  //       throw new Error("Token validation failed");
  //     }

  //     return true;
  //   } catch (err) {
  //     console.error("Token validation error:", err);
  //     return false;
  //   }
  // }, []);

  // useEffect(() => {
  //   const storedToken = localStorage.getItem("userToken");

  //   if (storedToken) {
  //     validateToken(storedToken).then((isValid) => {
  //       if (isValid) {
  //         setIsLoggedIn(true);
  //         setDialogOpen(false);
  //         if (location.pathname === "/protected") {
  //           navigate("/");
  //         }
  //       } else {
  //         localStorage.removeItem("userToken");
  //         setIsLoggedIn(false);
  //         if (location.pathname !== "/protected") {
  //           navigate("/protected");
  //         }
  //       }
  //     });
  //   } else {
  //     setIsLoggedIn(false);
  //     if (location.pathname !== "/protected") {
  //       navigate("/protected");
  //     }
  //   }
  // }, [location, navigate, validateToken]);

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();

  //   if (!tokenInput) {
  //     setError("Please enter an access key.");
  //     return;
  //   }

  //   try {
  //     const response = await fetch("https://api.izzat.xyz/authenticate", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ token: tokenInput }),
  //     });

  //     if (!response.ok) {
  //       throw new Error("Invalid access key or expired");
  //     }

  //     await response.json();

  //     localStorage.setItem("userToken", tokenInput);
  //     setIsLoggedIn(true);
  //     setDialogOpen(false);
  //     navigate("/");
  //   } catch (err: any) {
  //     setError(err.message || "Access key is invalid or has expired.");
  //     console.error("Authentication error:", err);
  //   }
  // };

  // const handleCloseDialog = () => {
  //   setDialogOpen(false);
  //   if (!isLoggedIn) {
  //     navigate("/protected");
  //   }
  // };

  return (
    <>
      {/* {dialogOpen && !isLoggedIn && (
        <Dialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          className="relative z-50"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
          <Dialog.Panel className="fixed inset-0 flex items-center justify-center">
            <div className="bg-white rounded-lg shadow-lg p-6 w-auto">
              <div className="flex justify-between items-center">
                <h2 className="text-lg font-semibold">
                  Greetings fellow traveler &#x1F44B;
                </h2>

                <button
                  onClick={handleCloseDialog}
                  className="text-gray-700 hover:text-gray-900"
                >
                  <XMarkIcon className="h-6 w-6" />
                </button>
              </div>
              <p className="text-sm">
                You're visiting a site that's still in development.
              </p>
              <p className="text-sm">
                Enter your access key below to unlock the full experience.
              </p>
              <input
                type="password"
                value={tokenInput}
                onChange={(e) => setTokenInput(e.target.value)}
                placeholder="••••••••"
                className="w-full mt-4 p-2 border rounded-lg focus:ring focus:ring-amber-300"
              />
              <button
                onClick={handleSubmit}
                className="w-full mt-4 p-2 bg-amber-500 text-white rounded-lg hover:bg-amber-600"
              >
                Enter
              </button>
              {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
            </div>
          </Dialog.Panel>
        </Dialog>
      )}

      {isLoggedIn && children} */}
      {children}
    </>
  );
};

export default UserSessionContextProvider;
